import firebase from "firebase/app";
import "firebase/auth";
import { fetchWithToken } from "./fetch";
import { firebaseFunctionHost } from "../config/fetch";
import { useInstantMessageSetter } from "state/instant-message";
import { useState } from "react";
type UpdatingState = "LOADING" | "FULFILLED" | "IDLE";
export function useViewerUpdater(user: firebase.User) {
  const [updatingState, setUpdatingState] = useState<UpdatingState>("IDLE");

  const updateViewerName = async (name: string, onFulfilled: () => void) => {
    setUpdatingState("LOADING");
    const userToken = await user.getIdToken();
    const res = await fetchWithToken(
      `${firebaseFunctionHost}/viewer/name/update`,
      userToken,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          name,
        }),
      }
    );
    // TODO: エラー時の制御
    onFulfilled();
    setUpdatingState("FULFILLED");
  };

  const updateViewer = async (
    name: string,
    surveyAnswers: {
      [surveyId: string]: { answer: string; answerId?: string };
    },
    onFulfilled: () => void
  ) => {
    setUpdatingState("LOADING");
    const userToken = await user.getIdToken();
    await fetchWithToken(`${firebaseFunctionHost}/viewer/update`, userToken, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        name,
        surveyAnswers,
      }),
    });
    onFulfilled();
    setUpdatingState("FULFILLED");
  };
  return { updatingState, updateViewerName, updateViewer };
}

export async function dismissAfterSessionSurvey(
  viewerReference: firebase.firestore.DocumentReference<Viewer>
) {
  return await viewerReference.update({
    dismissAfterSessionSurvey: true,
  });
}

export function useAfterSessionSurveyAction() {
  const [processState, setProcessState] = useState<UpdatingState>("IDLE");
  const setInstantMessage = useInstantMessageSetter();
  async function answerAfterSessionSurvey(
    user: firebase.User,
    surveyAnswers: {
      [surveyId: string]: { answer: string; answerId?: string };
    }
  ) {
    setProcessState("LOADING");
    const token = await user.getIdToken();
    setInstantMessage({
      title: "回答ありがとうございます！",
    });
    await fetchWithToken(
      `${firebaseFunctionHost}/answer-after-session-surveys`,
      token,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          surveyAnswers,
        }),
      }
    );
    setProcessState("FULFILLED");
  }

  return { answerAfterSessionSurvey, processState };
}
